import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import PawAnimation from "./PawAnimation";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import PageTitle from "./PageTitleCompoent";

import PhoneIcon from "../assets/Icons/PhoneIcons";
import MailIcons from "../assets/Icons/MailIcons";
import LocationIcon from "../assets/Icons/LocationIcon";
import api from "../api";

import "../css/AppointmentDetailsScreenTwo.css";
import "react-toastify/dist/ReactToastify.css";

export default function AppointmentDetailsScreenTwo() {
  const navigate = useNavigate();
  const location = useLocation();

  const { appointmentData } = location.state || {}; // Get appointmentData from passed state
  const [loading, setLoading] = useState(true);

  const handleBack = () => navigate(-1);
  
  const capitalizeFirst = (text) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : "";


  useEffect(() => {
    // brief entrance to allow AnimatePresence full-screen transition
    const t = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(t);
  }, []);

  if (loading) {
    return (
      <AnimatePresence>
        <motion.div
          className="full-screen-loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <PawAnimation />
        </motion.div>
      </AnimatePresence>
    );
  }

  if (!appointmentData) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>No Appointment Data Found</h2>
        <button onClick={handleBack}>Go Back</button>
      </div>
    );
  }

  // Map incoming data safely
  const doctorData = appointmentData.doctor || {};

  // Customer avatar
  const customerAvatar = appointmentData.customer_profile_image
    ? `${api.defaults.baseURL.split("/api")[0]}${appointmentData.customer_profile_image}`
    : "/default-avatar.png";

  // Doctor avatar
 // Doctor avatar
const doctorAvatar = doctorData.profile_image
  ? doctorData.profile_image.startsWith("http")
    ? doctorData.profile_image
    : `${api.defaults.baseURL.split("/api")[0]}${doctorData.profile_image}`
  : "/default-avatar.png";


  // Decide which avatar to show
  const avatarToShow =
    appointmentData.status?.toLowerCase() === "new"
      ? customerAvatar
      : doctorAvatar;

  // Doctor info (used for assigned/other appointments)
  const doctor = {
    name: doctorData.name || "Unknown",
    specialist: doctorData.specialization
      ? doctorData.specialization
          .map(
            (s) =>
              s
                .split("_")
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(" ")
          )
          .join(", ")
      : "Not Provided",
    email: doctorData.email || "Not Provided",
    phone: doctorData.mobile_number || "Not Provided",
    clinic: doctorData.clinical_name || "Not Provided",
    location: doctorData.clinic_address || "Not Provided",
    avatar: doctorAvatar,
  };

  // Check if it's a new appointment
  const isNewAppointment = appointmentData.status?.toLowerCase() === "new";

  return (
    <div className="appointment-details-two-container">
      <Sidebar />
      <div className="appointment-details-two-main">
        <Header />

        <motion.div
          className="appointment-details-two-content"
          style={{ textAlign: "left" }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <PageTitle
            title="Doctor Profile"
            subtitle="Appointment Details"
            onBack={handleBack}
            showBackArrow={true}
          />

          <motion.div
            className="appointment-details-two-card"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <div className="appointment-details-two-header-container">
              <div className="appointment-details-two-header">
                {/* Always show avatar */}
                <img
                  src={avatarToShow}
                  alt={
                    isNewAppointment
                      ? appointmentData.customer_name
                      : `Dr. ${doctor.name}`
                  }
                  className="appointment-details-two-avatar"
                />

                {/* Only show doctor info if not a new appointment */}
                {!isNewAppointment && (
                  <div className="appointment-details-two-info">
                    <div>
                      <div className="appointment-details-two-name-row">
                        <h2 className="appointment-details-two-name">
                          {doctor.name}
                        </h2>
                      </div>

                      <p className="appointment-details-two-subtitle">
                        {doctor.specialist}
                      </p>

                      <div className="appointment-details-two-contact">
                        <div className="appointment-details-two-contact-list">
                          <div className="appointment-details-two-contact-clinic-item">
                            <span>{doctor.clinic}</span>
                          </div>

                          <div className="appointment-details-two-contact-item">
                            <PhoneIcon className="appointment-details-two-contact-icon" />
                            <span>{doctor.phone}</span>
                          </div>

                          <div className="appointment-details-two-contact-item">
                            <MailIcons className="appointment-details-two-contact-icon" />
                            <span>{doctor.email}</span>
                          </div>

                          <div className="appointment-details-two-contact-item">
                            <LocationIcon className="appointment-details-two-contact-icon" />
                            <span>{doctor.location}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Always show appointment info */}
              <div className="appointment-details-two-flex">
  <div className="appointment-details-two-item">
    <label>Appointment Date & Time</label>
    <p>
      {appointmentData.appointment_date} at{" "}
      {appointmentData.appointment_time}
    </p>
  </div>

  <div className="appointment-details-two-item">
    <label>Service Availed</label>
    <p>{capitalizeFirst(appointmentData.service_type)}</p>
  </div>

  <div className="appointment-details-two-item">
    <label>Pet Owner's Name</label>
    <p>{capitalizeFirst(appointmentData.customer_name)}</p>
  </div>

  <div className="appointment-details-two-item">
    <label>Pet Details</label>
    <p>
      {capitalizeFirst(appointmentData.pet_name)}
    </p>
  </div>
  <div className="appointment-details-two-item">
    <label>Appointment Status</label>
    <p>{capitalizeFirst(appointmentData.status)}</p>
  </div>
  <div className="appointment-details-two-item">
    <label>Pet Breed</label>
    <p>   
      {capitalizeFirst(appointmentData.pet_breed)}      
    </p>
  </div>

  
</div>

            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
